// import ZJApp from '../../../api'
import ZJApi from './api.js'
// import ZJConfig from '../../config'
import utils from '../../utils'
 
const info = {
    service: 'BaseDataService',
    controller: 'UniformConfig'
};

const methods = [
    'GetConfigItemsListExt'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const MapCenterApi = ZJApi.defineNewApi('MapCenterApi', factory);

export default MapCenterApi;